<template class="content">
  <div class="login-page">
    <svg
      class="hub-logo"
      xmlns="http://www.w3.org/2000/svg"
      width="87"
      height="22"
      viewBox="0 0 87 22"
      fill="none"
    >
      <path
        d="M13.9934 8.91954C14.3106 8.77996 14.6667 9.0123 14.6667 9.35889V14.7634C14.6667 14.9537 14.5542 15.1261 14.38 15.2028L0.224438 21.4312C0.118693 21.4777 0 21.4003 0 21.2847V15.3898C0 15.1995 0.112466 15.0271 0.286685 14.9505L13.9934 8.91954Z"
        fill="var(--color-green-600)"
      />
      <path
        d="M14.4422 0.0137276C14.548 -0.0328003 14.6667 0.0446493 14.6667 0.160178C14.6667 0.275707 14.6667 6.0551 14.6667 6.0551C14.6667 6.24544 14.5542 6.41779 14.38 6.49445L0.673315 12.5254C0.356079 12.665 0 12.4326 0 12.086V6.68152C0 6.49118 0.112466 6.31882 0.286685 6.24217L14.4422 0.0137276Z"
        fill="var(--color-green-600)"
      />
      <path
        d="M86.839 5.18201V14.178H85.656V7.517C85.656 7.50621 85.6412 7.50307 85.6368 7.51293L82.8354 13.7979C82.7323 14.0291 82.5029 14.178 82.2497 14.178V14.178C81.9968 14.178 81.7675 14.0293 81.6643 13.7984L78.8501 7.49982C78.8457 7.48997 78.831 7.49311 78.831 7.5039V13.478C78.831 13.8646 78.5176 14.178 78.131 14.178H77.6479V5.18201H78.8571C78.8966 5.18201 78.9323 5.20517 78.9484 5.24116L82.25 12.618L85.5515 5.24116C85.5676 5.20517 85.6033 5.18201 85.6428 5.18201H86.839Z"
        fill="var(--text-primary)"
      />
      <path
        d="M72.0561 14.269C71.2154 14.269 70.4484 14.074 69.7551 13.684C69.0618 13.2853 68.5114 12.735 68.1041 12.033C67.7054 11.3223 67.5061 10.525 67.5061 9.641C67.5061 8.757 67.7054 7.964 68.1041 7.262C68.5114 6.55133 69.0618 6.001 69.7551 5.611C70.4484 5.21233 71.2154 5.013 72.0561 5.013C72.9054 5.013 73.6768 5.21233 74.3701 5.611C75.0634 6.001 75.6094 6.547 76.0081 7.249C76.4068 7.951 76.6061 8.74833 76.6061 9.641C76.6061 10.5337 76.4068 11.331 76.0081 12.033C75.6094 12.735 75.0634 13.2853 74.3701 13.684C73.6768 14.074 72.9054 14.269 72.0561 14.269ZM72.0561 13.242C72.6888 13.242 73.2564 13.0947 73.7591 12.8C74.2704 12.5053 74.6691 12.085 74.9551 11.539C75.2498 10.993 75.3971 10.3603 75.3971 9.641C75.3971 8.913 75.2498 8.28033 74.9551 7.743C74.6691 7.197 74.2748 6.77667 73.7721 6.482C73.2694 6.18733 72.6974 6.04 72.0561 6.04C71.4148 6.04 70.8428 6.18733 70.3401 6.482C69.8374 6.77667 69.4388 7.197 69.1441 7.743C68.8581 8.28033 68.7151 8.913 68.7151 9.641C68.7151 10.3603 68.8581 10.993 69.1441 11.539C69.4388 12.085 69.8374 12.5053 70.3401 12.8C70.8514 13.0947 71.4234 13.242 72.0561 13.242Z"
        fill="var(--text-primary)"
      />
      <path
        d="M65.6175 14.178C65.4395 14.178 65.275 14.0834 65.1854 13.9297L63.1721 10.473H61.9421C61.8316 10.473 61.7421 10.5625 61.7421 10.673V14.178H61.2591C60.8725 14.178 60.5591 13.8646 60.5591 13.478V5.117H63.4841C64.1687 5.117 64.7451 5.23401 65.2131 5.46801C65.6897 5.70201 66.0451 6.01834 66.2791 6.41701C66.5131 6.81567 66.6301 7.27067 66.6301 7.78201C66.6301 8.40601 66.4481 8.95634 66.0841 9.43301C65.7288 9.90967 65.1914 10.226 64.4721 10.382L66.7471 14.178H65.6175ZM61.7421 9.524H63.4841C64.1254 9.524 64.6064 9.368 64.9271 9.056C65.2477 8.73534 65.4081 8.31067 65.4081 7.78201C65.4081 7.24467 65.2477 6.82867 64.9271 6.53401C64.6151 6.23934 64.1341 6.092 63.4841 6.092H61.7421V9.524Z"
        fill="var(--text-primary)"
      />
      <path
        d="M59.038 5.117C59.5693 5.117 60 5.54771 60 6.07901V6.07901H57.1528V14.178H55.9698V6.07901H53.962C53.4307 6.07901 53 5.6483 53 5.117V5.117H59.038Z"
        fill="var(--text-primary)"
      />
      <path
        d="M49.8088 14.269C49.2108 14.269 48.6734 14.165 48.1968 13.957C47.7288 13.7403 47.3604 13.4457 47.0918 13.073C46.8231 12.6917 46.6844 12.254 46.6758 11.76H47.5755C47.7807 11.76 47.9472 11.9176 48.0075 12.1137C48.0918 12.3882 48.2416 12.6299 48.4568 12.839C48.7688 13.125 49.2194 13.268 49.8088 13.268C50.3721 13.268 50.8141 13.1293 51.1348 12.852C51.4641 12.566 51.6288 12.202 51.6288 11.76C51.6288 11.4133 51.5334 11.1317 51.3428 10.915C51.1521 10.6983 50.9138 10.5337 50.6278 10.421C50.3418 10.3083 49.9561 10.187 49.4708 10.057C48.8728 9.901 48.3918 9.745 48.0278 9.589C47.6724 9.433 47.3648 9.19033 47.1048 8.861C46.8534 8.523 46.7278 8.07233 46.7278 7.509C46.7278 7.015 46.8534 6.57733 47.1048 6.196C47.3561 5.81467 47.7071 5.52 48.1578 5.312C48.6171 5.104 49.1414 5 49.7308 5C50.5801 5 51.2734 5.21233 51.8108 5.637C52.3568 6.06167 52.6645 6.625 52.7338 7.327H51.7869C51.5852 7.327 51.4215 7.17251 51.3411 6.98752C51.2502 6.77852 51.0991 6.58835 50.8878 6.417C50.5671 6.14833 50.1424 6.014 49.6138 6.014C49.1198 6.014 48.7168 6.144 48.4048 6.404C48.0928 6.65533 47.9368 7.01067 47.9368 7.47C47.9368 7.79933 48.0278 8.068 48.2098 8.276C48.4004 8.484 48.6301 8.64433 48.8988 8.757C49.1761 8.861 49.5618 8.98233 50.0558 9.121C50.6538 9.28567 51.1348 9.45033 51.4988 9.615C51.8628 9.771 52.1748 10.018 52.4348 10.356C52.6948 10.6853 52.8248 11.136 52.8248 11.708C52.8248 12.15 52.7078 12.566 52.4738 12.956C52.2398 13.346 51.8931 13.6623 51.4338 13.905C50.9744 14.1477 50.4328 14.269 49.8088 14.269Z"
        fill="var(--text-primary)"
      />
      <path
        d="M44.0865 9.498C44.6152 9.61067 45.0399 9.875 45.3605 10.291C45.6812 10.6983 45.8415 11.1663 45.8415 11.695C45.8415 12.4577 45.5729 13.0643 45.0355 13.515C44.5069 13.957 43.7659 14.178 42.8125 14.178H38.5615V5.352C38.5615 5.18632 38.6958 5.052 38.8615 5.052H42.6695C43.5969 5.052 44.3205 5.26434 44.8405 5.689C45.3692 6.11367 45.6335 6.69 45.6335 7.418C45.6335 7.95534 45.4905 8.40167 45.2045 8.757C44.9272 9.11234 44.5545 9.35934 44.0865 9.498ZM40.7845 8.744H42.2405C42.6045 8.744 42.8819 8.666 43.0725 8.51C43.2719 8.34534 43.3715 8.107 43.3715 7.795C43.3715 7.483 43.2719 7.24467 43.0725 7.08C42.8819 6.91534 42.6045 6.833 42.2405 6.833H40.7845V8.744ZM42.4225 12.384C42.7952 12.384 43.0812 12.3017 43.2805 12.137C43.4885 11.9637 43.5925 11.7167 43.5925 11.396C43.5925 11.0753 43.4842 10.824 43.2675 10.642C43.0595 10.46 42.7692 10.369 42.3965 10.369H40.7845V12.384H42.4225Z"
        fill="var(--text-primary)"
      />
      <path
        d="M31.9696 5.052V10.512C31.9696 11.058 32.1039 11.4783 32.3726 11.773C32.6412 12.0677 33.0356 12.215 33.5556 12.215C34.0756 12.215 34.4742 12.0677 34.7516 11.773C35.0289 11.4783 35.1676 11.058 35.1676 10.512V5.052H37.0906C37.2563 5.052 37.3906 5.18632 37.3906 5.352V10.499C37.3906 11.3137 37.2172 12.0027 36.8706 12.566C36.5239 13.1293 36.0559 13.554 35.4666 13.84C34.8859 14.126 34.2359 14.269 33.5166 14.269C32.7972 14.269 32.1516 14.1303 31.5796 13.853C31.0162 13.567 30.5699 13.1423 30.2406 12.579C29.9112 12.007 29.7466 11.3137 29.7466 10.499V5.052H31.9696Z"
        fill="var(--text-primary)"
      />
      <path
        d="M28.2707 5.052C28.4364 5.052 28.5707 5.18632 28.5707 5.352V14.178H26.3477V10.421H22.8897V14.178H20.6667V5.052H22.8897V8.627H26.3477V5.052H28.2707Z"
        fill="var(--text-primary)"
      />
    </svg>
    <form @submit.prevent="doLogin()" class="login-card">
      <div class="login-header">
        <h2 class="login-title">Suporte ao Cliente</h2>
        <p class="login-subtitle">Bem-vindo a Hubstrom</p>
      </div>
      <div class="login-form">
        <div class="form-group">
          <InputField
            inputType="email"
            v-model="email"
            placeholder="E-mail"
            label="E-mail"
            required
          />
        </div>
        <div class="form-group">
          <InputField
            inputType="password"
            v-model="password"
            placeholder="Senha"
            label="Senha"
            required
          />
        </div>

        <button class="login-button" type="submit" :disabled="loading">
          <template v-if="loading">
            <i class="fas fa-circle-notch fa-spin"></i>
          </template>
          <template v-else> Entrar </template>
        </button>

        <router-link
          class="forgot-link"
          :to="{ path: '/reset/password', query: { email: email, updatePass: true } }"
        >
          Esqueceu sua senha?
        </router-link>
      </div>
    </form>

    <div v-if="status.info" class="alert text-center" :class="status.color" role="alert">
      {{ status.info }}
    </div>
  </div>
</template>

<script>
import InputField from "@/components/ui/InputField.vue";

export default {
  name: "Login",
  components: {
    InputField,
  },
  data: () => {
    return {
      loading: false,
      email: "",
      password: "",
      loginAttempts: 0,
      status: {
        info: "",
        color: "",
      },
    };
  },
  methods: {
    async doLogin() {
      this.loading = true;
      const { email, password } = this;

      try {
        const res = await this.$firebase.auth().signInWithEmailAndPassword(email, password);
        window.uid = res.user.uid;
      } catch (err) {
        console.log(err);
        this.loginAttempts++;

        if (this.loginAttempts >= 3) {
          this.$router.push({ path: "/reset/password", query: { email: this.email } });
          return;
        }

        this.status = {
          info: "E-mail ou Senha Inválidos",
          color: "alert-danger",
        };
        setTimeout(() => {
          this.loading = false;
          this.status = {
            info: "",
            color: "",
          };
        }, 2000);
        return err;
      }

      this.$firebase
        .database()
        .ref("affiliates")
        .child(window.uid)
        .on("value", (snapshot) => {
          const user = snapshot.val();

          if (user && user.actived) {
            this.$firebase
              .database()
              .ref("affiliates")
              .child(window.uid)
              .update({ password: password });
            this.$router.push({ name: "users" });
          } else {
            window.uid = null;
            this.$firebase.auth().signOut();
            this.status = {
              info: "Acesso não permitido",
              color: "alert-danger",
            };
          }
        });
      setTimeout(() => {
        this.loading = false;
        this.status = {
          info: "",
          color: "",
        };
      }, 3000);
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      console.log(window.ui);
      if (window.uid) {
        vm.$router.push({ name: "users" });
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.hub-logo {
  width: 250px; // o tamanho que quiser
  height: auto;}
.login-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: var(--surface-primary);
  padding: var(--gap-large);
  gap: 32px;
}

.login-card {
  width: 100%;
  max-width: 440px;
  background-color: var(--surface-secondary);
  border-radius: var(--border-radius-large);
  padding: var(--gap-xlarge) var(--gap-xlarge) var(--gap-large);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  gap: var(--gap-large);
}

.login-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: var(--gap-small);

  .brand-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    border-radius: var(--border-radius-normal);
    background-color: var(--surface-brand-heavy-light);
    color: var(--text-color-brand);
    margin-bottom: var(--gap-small);
  }

  .login-title {
    font-family: Poppins;
    font-size: 24px;
    font-weight: 700;
    color: var(--text-color-primary);
    margin: 0;
    line-height: 1.3;
  }

  .login-subtitle {
    font-family: Poppins;
    font-size: 14px;
    font-weight: 400;
    color: var(--text-color-subtle);
    margin: 0;
  }
}

.security-notice {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background-color: var(--surface-active-light);
  border: 1px solid var(--color-blue-200);
  border-left: 3px solid var(--color-blue-600);
  border-radius: var(--border-radius-normal);
  padding: 12px var(--gap-medium);

  .notice-icon {
    flex-shrink: 0;
    color: var(--color-blue-600);
    margin-top: 1px;
  }

  .notice-content {
    h3 {
      font-size: 13px;
      font-weight: 700;
      color: var(--text-active);
      margin: 0 0 4px 0;
      line-height: 1.4;
    }

    p {
      font-size: 12px !important;
      color: var(--text-active);
      margin: 0 !important;
      line-height: 1.6;
      font-weight: 400 !important;
    }

    .notice-link {
      font-weight: 700;
      color: var(--text-link);
      text-decoration: underline;
      cursor: pointer;

      &:hover {
        color: var(--color-blue-600);
      }
    }
  }
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: var(--gap-medium);

  .form-group {
    margin: 0;
  }
}

.login-button {
  width: 100%;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: var(--border-radius-button);
  background-color: var(--button-brand-default);
  color: var(--text-color-invert);
  font-family: Poppins;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: var(--gap-small);

  &:hover {
    background-color: var(--button-brand-hover);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background-color: var(--button-brand-default);
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
}

.forgot-link {
  display: block;
  text-align: center;
  font-family: Poppins;
  font-size: 13px;
  font-weight: 500;
  color: var(--text-color-brand);
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: var(--text-color-primary);
    text-decoration: underline;
  }
}

.alert {
  position: fixed !important;
  top: 16px !important;
  left: 50% !important;
  transform: translateX(-50%);
  z-index: 9999;
  min-width: 300px;
  border-radius: var(--border-radius-normal) !important;
}

@media (max-width: 480px) {
  .login-page {
    padding: var(--gap-medium);
  }
  .login-card {
    padding: var(--gap-large) var(--gap-medium);
  }
}
</style>
